<template>
  <div id="advantages" class="section-advantages">
    <div
      class="section-advantages__with-icons"
      :class="{'section-advantages__with-icons_right': right}"
    >
      <div class="wrapper">
        <div class="icons-top">
          <div class="icon">
            <SvgOfferAdvantage1 />
            <div class="title">{{ $t('quickStart') }}</div>
          </div>
          <div class="icon">
            <SvgOfferAdvantage2 />
            <div class="title">{{ $t('intuitiveInterface') }}</div>
          </div>
          <div class="icon">
            <SvgOfferAdvantage3 />
            <div class="title">{{ $t('realtimeDesign') }}</div>
          </div>
          <div class="icon">
            <SvgOfferAdvantage4 />
            <div class="title">{{ $t('instantVisualization') }}</div>
          </div>
        </div>
        <div class="icons-bottom">
          <div class="icon">
            <SvgOfferAdvantage5 />
            <div class="title">{{ $t('finetuningScenes') }}</div>
          </div>
          <div class="icon">
            <SvgOfferAdvantage6 />
            <div class="title">{{ $t('readyModels') }}</div>
          </div>
          <div class="icon">
            <SvgOfferAdvantage7 />
            <div class="title">{{ $t('vrSupport') }}</div>
          </div>
          <div class="icon">
            <SvgOfferAdvantage8 />
            <div class="title">{{ $t('creativeFreedom') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="section-advantages__with-text"
      :class="{'section-advantages__with-text_right': right}"
    >
      <div class="wrapper">
        <div class="title">
          {{ $t('endlessInteriorPossibilities') }}
        </div>
        <div class="subtitle">{{ $t('create15Minutes') }}</div>
        <ui-button
          :size="ButtonSizeType.large"
          :label="$t('tryForFree')"
          color="primary-offer"
          ref="btnRef"
          class="dwnload-btn btn low-btn"
          @click="actionHandler"
        >
          <template v-if="!isMobile" #before
            ><IconWindows
          /></template>
        </ui-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ButtonSizeType} from '~/interfaces/ui/button';
import {useBaseStore} from '~/modules/BaseModule/base.store';
import IconWindows from '~/assets/svg/windows-icon.svg';
import {useI18n} from 'vue-i18n';
import {useDirectionStore} from '~/store/direction.store';

const router = useRouter();
const base = useBaseStore();
const {locale} = useI18n();
const isMobile = computed(() => base.isMobile);
const direction = useDirectionStore();
const right = computed(() => direction.$state.isRight);

import {goTo} from '~/helpers/baseFunction';

const actionHandler = () => {
  goTo('#tariff');
}
</script>

<style scoped lang="scss">
.section-advantages {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100vh;
  //margin-top: $mt-45;

  &__with-icons {
    flex-basis: 50%;
    height: 100vh;
    padding: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
      270deg,
      var(--var-blue-50) 0%,
      var(--var-blue-300) 100%
    );

    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      gap: $g-21;
      .icons-top {
        display: flex;
        align-items: flex-start;
        gap: $g-4;
      }
      .icons-bottom {
        display: flex;
        gap: $g-4;
      }

      .icon {
        width: 100%;
        height: 100%;
        max-width: 130px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: $g-4;
        .title {
          @include launcher-p3;
          text-align: center;
        }
      }
    }
  }
  &__with-text {
    flex-basis: 50%;
    height: 100vh;
    align-items: center;
    display: flex;
    justify-content: center;
    background: var(--var-white-200);
    padding: 60px;

    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      max-width: 564px;

      .title {
        @include headline-h1;
      }
      .subtitle {
        @include launcher-p1;
        margin-top: $mt-6;
      }

      button {
        margin-top: $mt-12;
        max-width: 335px;
        width: 100%;

        @media (max-width: $md) {
          max-width: 100%;
        }
      }
    }
  }

  @media (max-width: $lg) {
    flex-direction: column;
    &__with-icons {
      position: unset;
      //transform: translateX(-16px);
      height: 100%;
      width: 100%;
      justify-content: center;
      min-height: 50vh;
      padding: 20px 0px;

      &_right {
        //transform: translateX(16px);
      }

      .wrapper {
        width: 100%;
        gap: $g-4;
        align-items: center;

        @media (max-width: $md) {
          width: unset;
        }
      }

      .icons-top {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: $g-4;
      }
      .icons-bottom {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: $g-4;
      }
    }

    &__with-text {
      position: unset;
      height: 100%;
      //transform: translateX(-16px);
      width: 100vw;
      justify-content: center;
      min-height: 50vh;
      padding: 20px 0px;

      &_right {
        //transform: translateX(16px);
      }
      .wrapper {
        padding: 0px 20px;
      }

      @media (max-width: $md) {
        padding: $p-13 0px;
      }
    }
  }

  @media (min-width: 2000px) {
    min-height: 1000px;
  }

  @media (max-width: $lg) {
    //margin-top: $mt-10;
  }
}
</style>
